import Credentials from "../dto/Credentials";
import ICredentials from "../dto/ICredentials";
import IToken from "../dto/IToken";
import { IEnvSettings } from "@/module/main";

class Mapper {
    public toLoginRequest(envSettings: IEnvSettings): ICredentials {
        return new Credentials(envSettings.username, envSettings.password);
    }

    public fromLoginResponse(response: any): IToken {
        return response as IToken;
    }
}

export default new Mapper();
